import ReactDOM from 'react-dom';
import preloaded from '../src/preloaded.js';
import ArticlePageControls from '../src/articles/ArticlePageControls.js';

ReactDOM.render(
  <ArticlePageControls article={preloaded.article} liked={preloaded.liked} />
, document.getElementById('app'));
